<script setup lang="ts">
import { DropdownItem } from 'vant';
import { useFavoriteFabric } from './use-favorite-fabric.ts';

const { date, enterprise, dateOptions, enterpriseOptions } = useFavoriteFabric();
</script>

<template>
  <DropdownItem v-model="date" :options="dateOptions" />
  <DropdownItem v-model="enterprise" :options="enterpriseOptions" />
</template>

<style scoped>

</style>
